/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCodeSimple: {
  name: 'code-simple';
  data: string;
} = {
  name: 'code-simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.39 3.312a.5.5 0 1 0-.78-.624l-4 5a.5.5 0 0 0 0 .624l4 5a.5.5 0 0 0 .78-.624L1.64 8l3.75-4.688Zm6-.624a.5.5 0 1 0-.78.624L14.36 8l-3.75 4.688a.5.5 0 1 0 .78.624l4-5a.5.5 0 0 0 0-.624l-4-5Z" fill="currentColor"/></svg>`,
};
